// extracted by mini-css-extract-plugin
export default {"customQuestionsContainer":"CustomQuestions_customQuestionsContainer__jtLQG"};